const defaultState = {
  referenceCode: '',
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  plainPassword: '',
  plainPasswordMatch: '',
  sexOptions: [],
  sex: '',
  invoiceCompany: '',
  invoiceVatNumber: '',
  invoiceAddress: '',
  invoiceComments: '',
  knowAboutUsOptions: [],
  knowAboutUs: '',
  knowAboutUsOther: '',
  messagesTerms: true,
  messagesTermsContent: '',
  smsClientTags: [],
  passwordError: '',
  loading: false,
  fetching: true,
  birthday: null,
};

export default defaultState;
